var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "chatCloseSettingsButton" } },
    [
      _vm.visitorBanModal
        ? _c("VisitorBanModal", {
            attrs: {
              visitor: _vm.contact,
              "ban-modal-visible": _vm.visitorBanModal,
            },
            on: {
              changed: _vm.visitorBanUpdated,
              close: function ($event) {
                _vm.visitorBanModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.privateMessage
        ? _c("PrivateMessage", {
            attrs: { "conversation-id": _vm.contact.lastConversation._id },
            on: {
              close: function ($event) {
                _vm.privateMessage = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.assignAgent
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "assign-agent",
                title: _vm.$t("message.addRepresentative"),
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.assignAgent = false
                },
              },
            },
            [
              _c("AgentList", {
                attrs: { assign: true, "show-online-agents": true },
                on: {
                  close: function () {
                    return _vm.closeModal("assign")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.forwardAgent
        ? _c(
            "Modal2",
            {
              attrs: {
                id: "forward-agent",
                title: _vm.$t("message.forwardChat"),
                "show-footer": false,
              },
              on: {
                cancel: function ($event) {
                  _vm.forwardAgent = false
                },
              },
            },
            [
              _c("ChatForwardWindow", {
                attrs: { contact: _vm.contact },
                on: {
                  close: function ($event) {
                    _vm.forwardAgent = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSessionTerminationModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.endChatWizard"),
                showFooter: false,
                xlarge: "",
                top: 10,
                className: "session-termination-modal",
              },
              on: { cancel: _vm.handleSessionCancel },
            },
            [
              _c("SessionTermination", {
                attrs: { contact: _vm.contact },
                on: {
                  terminate: _vm.handleSessionTerminate,
                  cancel: _vm.handleSessionCancel,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCapiEventModal
        ? _c("SendCapiEventModal", {
            attrs: { visible: _vm.showCapiEventModal, contact: _vm.contact },
            on: {
              cancel: function ($event) {
                _vm.showCapiEventModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showWebphoneSelectionModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("chat.chatCloseSettings.selectPhone"),
                description: _vm.$t(
                  "chat.chatCloseSettings.selectPhoneDescription",
                  { number: _vm.pendingPhoneNumber }
                ),
                okText: _vm.$t("chat.chatCloseSettings.call"),
                cancelText: _vm.$t("message.cancel"),
                className: "webphone-selection-modal",
              },
              on: {
                cancel: _vm.cancelWebphoneSelection,
                ok: _vm.confirmWebphoneSelection,
              },
            },
            [
              _c(
                "div",
                { staticClass: "webphone-channel-list" },
                _vm._l(_vm.availableWebphoneChannels, function (channel) {
                  return _c(
                    "div",
                    {
                      key: channel._id,
                      staticClass: "channel-option",
                      class: {
                        selected: _vm.selectedChannelId === channel._id,
                      },
                      on: {
                        click: function ($event) {
                          _vm.selectedChannelId = channel._id
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "channel-radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedChannelId,
                              expression: "selectedChannelId",
                            },
                          ],
                          attrs: {
                            type: "radio",
                            id: "channel-" + channel._id,
                          },
                          domProps: {
                            value: channel._id,
                            checked: _vm._q(_vm.selectedChannelId, channel._id),
                          },
                          on: {
                            change: function ($event) {
                              _vm.selectedChannelId = channel._id
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "channel-icon" }, [
                        channel.type === "webphone-telnyx"
                          ? _c("img", {
                              attrs: {
                                src: "/static/img/telnyx.png",
                                alt: "Telnyx",
                              },
                            })
                          : channel.type === "webphone-netgsm"
                          ? _c("img", {
                              attrs: {
                                src: "/static/img/netgsm.png",
                                alt: "NetGSM",
                              },
                            })
                          : _c(
                              "i",
                              { staticClass: "material-icons webphone-icon" },
                              [
                                _vm._v(
                                  "\n                        phone\n                    "
                                ),
                              ]
                            ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "channel-info" }, [
                        _c("div", { staticClass: "channel-name" }, [
                          _vm._v(
                            _vm._s(
                              channel.name ||
                                _vm.$t("chat.chatCloseSettings.unnamedChannel")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "channel-details" }, [
                          _c("span", { staticClass: "channel-type" }, [
                            _vm._v(
                              _vm._s(_vm.getChannelTypeDisplay(channel.type))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.$_.get(channel, "payload.callerPhoneNumber")
                            ? _c("span", { staticClass: "channel-phone" }, [
                                _vm._v(
                                  "\n                            • " +
                                    _vm._s(channel.payload.callerPhoneNumber) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "channel-arrow" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("chevron_right"),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "user-meta", on: { click: _vm.viewContactProfile } },
        [
          _c("ContactAvatar", {
            attrs: { contact: _vm.contact, size: "smallest" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "chat-contact-details-wrapper" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      followCursor: true,
                      placement: "bottom",
                      delay: [300, 0],
                    },
                    expression:
                      "{ followCursor: true, placement: 'bottom', delay: [300, 0] }",
                  },
                ],
                ref: "visitorNameInput",
                staticClass: "chat-contact-info chat-visitor-name-field",
                attrs: {
                  placeholder: _vm.$t("chat.chatCloseSettings.typeVisitorName"),
                  content: _vm.getFullname(),
                },
                on: {
                  keydown: _vm.handleVisitorNameInputKeyDown,
                  keyup: _vm.handleVisitorNameInputKeyUp,
                },
              },
              [
                _vm.contact.vipCustomer
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                              delay: [600, 0],
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                          },
                        ],
                        staticClass: "material-icons vip",
                        attrs: {
                          content: _vm.$t(
                            "chat.chatCloseSettings.vipCustomerTooltip"
                          ),
                        },
                      },
                      [_vm._v("\n                    star\n                ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "visitor-name-text" }, [
                  _vm._v(_vm._s(_vm.getFullname())),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat-contact-info chat-visitor-platform-field" },
              [
                _c(
                  "div",
                  { staticClass: "chat-platform-info-wrapper" },
                  [
                    _c("PlatformIcon", {
                      attrs: {
                        platform: _vm.channelType,
                        size: 12,
                        "tippy-disabled": true,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom",
                              delay: [300, 0],
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom', delay: [300, 0] }",
                          },
                        ],
                        staticClass: "chat-platform-text-label",
                        attrs: { content: _vm.platformTooltip },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.platformTooltip) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.contact.email && _vm.contact.email !== ""
                      ? [
                          _c(
                            "span",
                            { staticClass: "chat-platform-separator" },
                            [_vm._v("-")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "material-icons chat-contact-icon" },
                            [_vm._v("mail")]
                          ),
                          _vm._v(" "),
                          _vm.hasUserMail()
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom",
                                        delay: [300, 0],
                                      },
                                      expression:
                                        "{ followCursor: true, placement: 'bottom', delay: [300, 0] }",
                                    },
                                  ],
                                  staticClass: "chat-platform-email-link",
                                  attrs: { content: _vm.getEmail() },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "mailto:" + _vm.getEmail(),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.getEmail()))]
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom",
                                        delay: [300, 0],
                                      },
                                      expression:
                                        "{ followCursor: true, placement: 'bottom', delay: [300, 0] }",
                                    },
                                  ],
                                  staticClass: "chat-platform-phone-link",
                                  attrs: { content: _vm.getChannelNumber() },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "tel:" + _vm.getChannelNumber(),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.getChannelNumber()))]
                                  ),
                                ]
                              ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "conversation-actions" },
        [
          _c("ContactProfileAutomationButton", {
            attrs: { "contact-id": _vm.contact._id, "show-text": false },
          }),
          _vm._v(" "),
          _c("AiVoiceAgentCallStarter", {
            attrs: {
              contact: _vm.contact,
              "default-to-number":
                _vm.contact.phone || _vm.contact.whatsappNumber,
            },
          }),
          _vm._v(" "),
          _vm.contact.phone || _vm.contact.whatsappNumber
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { followCursor: true, placement: "bottom" },
                      expression: "{ followCursor: true, placement: 'bottom' }",
                    },
                  ],
                  staticClass: "conversation-actions-button webphone-call",
                  attrs: {
                    content: _vm.$t("chat.chatCloseSettings.webphoneCall"),
                  },
                  on: { click: _vm.startWebphoneCall },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "material-icons",
                      staticStyle: { color: "white !important" },
                    },
                    [_vm._v("phone")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isShowing("join-conversation")
            ? _c(
                "SupsisButton",
                { staticClass: "d-none", attrs: { primary: "" } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("chatWindow.watching")) +
                      "\n        "
                  ),
                ]
              )
            : _vm.isShowing("call-features") &&
              !_vm.videoCallMode &&
              !_vm.contact.whatsappNumber &&
              !_vm.contact.instagramUserId &&
              !_vm.contact.messengerUserId &&
              !_vm.contact.telegramUserId
            ? _c("div", { staticClass: "call-features" }, [
                _c(
                  "div",
                  {
                    staticClass: "conversation-actions-button call",
                    on: {
                      click: function ($event) {
                        return _vm.$feature.beforeStartVoiceCall(
                          _vm.callVoiceCall
                        )
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("call"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "conversation-actions-button video-call",
                    on: {
                      click: function ($event) {
                        return _vm.$feature.beforeStartVideoCall(
                          _vm.callVideoCall
                        )
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "material-icons" }, [
                      _vm._v("video_call"),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-popover",
            {
              attrs: {
                overlayClassName: "actionSettingsButton",
                "data-v-step": "17",
                placement: "bottomRight",
                title: "",
                trigger: "click",
              },
              scopedSlots: _vm._u([
                {
                  key: "content",
                  fn: function () {
                    return [
                      _vm.user
                        ? _c("div", { staticClass: "more-actions" }, [
                            _vm.isShowing("assign-agent")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-button",
                                    on: { click: _vm.assignRep },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "action-button-icon" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v("person_add")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "action-button-text" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.assignRep"))
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowing("auto-translate")
                              ? _c("div", { staticClass: "action-button" }, [
                                  _c(
                                    "div",
                                    { staticClass: "action-button-icon" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "material-icons" },
                                        [_vm._v("translate")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "action-button-text" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$t("message.autoTranslate")
                                          ) +
                                          " :\n                            "
                                      ),
                                      _c("a-switch", {
                                        staticClass: "ml-2 mr-2",
                                        attrs: {
                                          checked: _vm.autoTranslateEnabled,
                                          size: "small",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$emit(
                                              "autoTranslateChanged",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "action-button" }, [
                              _c("div", { staticClass: "action-button-icon" }, [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("visibility_off"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "action-button-text" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$t(
                                          "chat.chatCloseSettings.hideSystemMessages"
                                        )
                                      ) +
                                      " :\n                            "
                                  ),
                                  _c("a-switch", {
                                    staticClass: "ml-2 mr-2",
                                    attrs: {
                                      checked: _vm.hideSystemMessages,
                                      size: "small",
                                    },
                                    on: {
                                      change: _vm.toggleHideSystemMessages,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "action-button" }, [
                              _c("div", { staticClass: "action-button-icon" }, [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("bug_report"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "action-button-text" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$t(
                                          "chat.chatCloseSettings.chatbotDebugMode"
                                        )
                                      ) +
                                      " :\n                            "
                                  ),
                                  _c("a-switch", {
                                    staticClass: "ml-2 mr-2",
                                    attrs: {
                                      checked: _vm.debugModeEnabled,
                                      size: "small",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.$emit(
                                          "debugModeChanged",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.isShowing("leave-chat")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-button",
                                    on: { click: _vm.leave },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "action-button-icon" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v("logout")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "action-button-text" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t("message.leaveChat")
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "action-button",
                                on: { click: _vm.createTask },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "action-button-icon" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("add_task")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "action-button-text" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t(
                                            "chat.chatCloseSettings.createTask"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "keyboard-shortcut" },
                                      [_vm._v("Ctrl T")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.canToggleAnswerStatus
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-button",
                                    on: { click: _vm.toggleAnswerStatus },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "action-button-icon" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v(_vm._s(_vm.answerStatusIcon))]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "action-button-text" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.answerStatusButtonText) +
                                            "\n                            "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "keyboard-shortcut" },
                                          [_vm._v("C")]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "action-button",
                                on: { click: _vm.toggleUnread },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "action-button-icon" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v(_vm._s(_vm.unreadStatusIcon))]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "action-button-text" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.unreadStatusButtonText) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isShowing("forward-agent")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-button",
                                    on: { click: _vm.forwardRep },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "action-button-icon" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v("person_4")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "action-button-text" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t("message.forwardRep")
                                            ) +
                                            "\n                            "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "keyboard-shortcut" },
                                          [_vm._v("Ctrl F")]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowing("private-message")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-button",
                                    on: { click: _vm.pm },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "action-button-icon" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v("mail_lock")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "action-button-text" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t("message.privateMessage_")
                                            ) +
                                            "\n                            "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "keyboard-shortcut" },
                                          [_vm._v("Ctrl P")]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkPermission(
                              _vm.PERMISSION_TYPES["visitor.block"].tr.name
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-button",
                                    on: { click: _vm.ban },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "action-button-icon" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v("block")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "action-button-text" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$t("message.block_")) +
                                            "\n                            "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "keyboard-shortcut" },
                                          [_vm._v("Ctrl B")]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "action-button",
                                on: { click: _vm.viewContactProfile },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "action-button-icon" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("person")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "action-button-text" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t(
                                            "chat.chatCloseSettings.showProfile"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "keyboard-shortcut" },
                                      [_vm._v("Ctrl O")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isMetaPlatform()
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-button",
                                    on: { click: _vm.openCapiEventModal },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "action-button-icon" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v("ads_click")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "action-button-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "chat.chatCloseSettings.sendCapiEvent"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShowing("close-chat")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "action-button close-chat-button",
                                    on: { click: _vm.closeChat },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "action-button-icon" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v("power_settings_new")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "action-button-text" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$t("message.endChat")) +
                                            "\n                            "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "keyboard-shortcut" },
                                          [_vm._v("Ctrl W")]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.isPopoverVisible,
                callback: function ($$v) {
                  _vm.isPopoverVisible = $$v
                },
                expression: "isPopoverVisible",
              },
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "conversation-actions-button more-vert" },
                [
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("more_vert"),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }